import { z } from 'zod';
import { websiteUserRoleSchema } from '../user/index.js';
export const userCookieSchema = z.object({
    _id: z.string().optional(),
    role: websiteUserRoleSchema.optional(),
    isBroker: z.boolean(),
    email: z.string().optional(),
    emailArchive: z.array(z.string()),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    sugarID: z.string().optional(),
});
